import React, { useState } from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import ImgCrop from "antd-img-crop";
import { UPLOAD_URL } from "../lib/env";
import { useUser } from "../DataProvider";

const { Dragger } = Upload;

type FileUploadProps = {
  onFileUploaded: (data: {
    fileuploaded: boolean;
    name: string;
    folder: string;
  }) => void;
  enableCrop?: boolean;
  uploadPath?: string;
  aspect?: number;
};

const FileUpload: React.FC<FileUploadProps> = ({
  onFileUploaded,
  enableCrop = false,
  uploadPath = "",
  aspect = 16 / 9,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const { token } = useUser();
  const [uploading, setUploading] = useState<boolean>(false);

  const handleBeforeUpload = (file: File) => {
    setFile(file);
    return false;
  };

  const handleUpload = async () => {
    if (!file) {
      message.error("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    setUploading(true);

    try {
      const response = await axios.post(UPLOAD_URL + uploadPath, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 201) {
        const responseData = response.data;
        message.success("File uploaded successfully!");

        onFileUploaded({
          fileuploaded: true,
          name: responseData.name,
          folder: responseData.folder,
        });
      } else {
        message.error("File upload failed. Please try again.");
      }
    } catch (error) {
      message.error("An error occurred during the upload.");
      console.error("Upload error:", error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {enableCrop ? (
        <ImgCrop aspect={aspect}>
          <Dragger
            beforeUpload={handleBeforeUpload}
            maxCount={1}
            accept="image/*"
            className="w-full"
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">
              Drag & Drop a file here, or click to select
            </p>
          </Dragger>
        </ImgCrop>
      ) : (
        <Dragger
          beforeUpload={handleBeforeUpload}
          maxCount={1}
          accept="image/*"
          className="w-full"
        >
          <p className="ant-upload-drag-icon">
            <UploadOutlined />
          </p>
          <p className="ant-upload-text">
            Drag & Drop a file here, or click to select
          </p>
        </Dragger>
      )}

      <Button
        type="primary"
        onClick={handleUpload}
        loading={uploading}
        disabled={!file}
        className="mt-4 w-full"
      >
        {uploading ? "Uploading" : "Upload"}
      </Button>
    </div>
  );
};

export default FileUpload;
